import { render } from "./dshcy.vue?vue&type=template&id=358934bb&scoped=true&ts=true"
import script from "./dshcy.vue?vue&type=script&lang=ts"
export * from "./dshcy.vue?vue&type=script&lang=ts"

import "./dshcy.vue?vue&type=style&index=0&id=358934bb&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358934bb"]])

export default __exports__